import * as React from 'react';
import { SVGProps } from 'react';

const SvgSurfCylinder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <ellipse cx='8' cy='12.6667' rx='6' ry='2' stroke='#FFBE98' />
    <path d='M14 3.33341V12.6667' stroke='#FF4D00' />
    <path d='M2 3.33341V12.6667' stroke='#FF4D00' />
    <ellipse cx='8' cy='3.33333' rx='6' ry='2' stroke='#FF4D00' />
    <path
      d='M14 12.6667C14 13.7713 11.3137 14.6667 8 14.6667C4.68629 14.6667 2 13.7713 2 12.6667'
      stroke='#FF4D00'
    />
  </svg>
);

export default SvgSurfCylinder;
